import { faCaretRight as fasCaretRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import type { ReactNode } from "react";
import React from "react";
import type { ColProps } from "react-bootstrap";
import { Accordion, Col } from "react-bootstrap";

interface Props {
	title?: string;
	children: ReactNode;
	renderAccordionInDesktopMode?: boolean;
	colProps?: ColProps;
	onClick?(isOpen: boolean): void;
}

interface State {
	open: boolean;
}

export class MarketingAccordion extends React.Component<Props, State> {
	public constructor(props: Props) {
		super(props);

		this.state = { open: false };
	}

	public render(): ReactNode {
		const {
			title = "Speciális ajánlat",
			children,
			renderAccordionInDesktopMode = false,
			colProps = { xl: 7, md: 6 },
			onClick,
		} = this.props;
		const { open } = this.state;

		return (
			<>
				<Accordion className={`col-12 my-2${renderAccordionInDesktopMode ? "" : " d-md-none"}`}>
					<Accordion.Toggle
						as="div"
						className="text-center cursor-pointer"
						eventKey="bm-discount"
						onClick={() => {
							this.toggleHandler();

							if (typeof onClick === "function") {
								onClick(!open);
							}
						}}
					>
						<FontAwesomeIcon icon={fasCaretRight} rotation={open ? 270 : 90} className="mr-2" />
						{title}
						<FontAwesomeIcon icon={fasCaretRight} rotation={open ? 270 : 90} className="ml-2" />
					</Accordion.Toggle>
					<Accordion.Collapse eventKey="bm-discount">
						<div className="marketing-block">{children}</div>
					</Accordion.Collapse>
				</Accordion>
				{!renderAccordionInDesktopMode && (
					<Col className="d-none d-md-block marketing-block" {...colProps}>
						{children}
					</Col>
				)}
			</>
		);
	}

	@autobind
	private toggleHandler() {
		const { open } = this.state;

		this.setState({
			open: !open,
		});
	}
}
